import React, { Component } from 'react';
import ReportPage from './ReportPage';
import GrowthChart from '../GrowthChart';
import DOL from '../../img/img-dol.png';

class GrowthPathsPage extends Component {
    render() {
        let asOfDate = this.props.dataManager.asOfDate;

		//console.log(this.props)
        return (
            <ReportPage {...this.props} addBreak={true} title="Risk/Reward Analysis" subtitle="Comparison of Equity Allocations and Associated Risks" pageNumber={this.props.pageNumber} className="glide-paths-page fund-selector">
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>
                    Understand the principal strategies and risks of the fund, or of any underlying asset classes or investments that may be held by the TDF. If the employees don't understand the fund's glide path assumptions when they invest, they may be surprised later if it turns out not to be a good fit for them.
                    </p>
                </div>
                    <GrowthChart id="growthChartReport" {...this.props}  tabIndex={this.props.risk}/>
                <div style={{fontSize: "12px"}}>Data as of <span className="asOfDate">{asOfDate}</span></div>
                <div style={{fontSize: "12px"}}>Source: Morningstar, Fund Prospectuses, American Century Investments</div>
             
               
            </ReportPage>
        );
    }
}

export default GrowthPathsPage;
